module.exports = __webpack_public_path__ + "img/001-voice-command.da07dbed.svg";